import { render, staticRenderFns } from "./PostInPccModal.vue?vue&type=template&id=3b7643f4&scoped=true&"
import script from "./PostInPccModal.vue?vue&type=script&lang=ts&"
export * from "./PostInPccModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7643f4",
  null
  
)

export default component.exports